var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-43.9%",
    y: "-66.1%",
    width: "187.8%",
    height: "232.2%",
    filterUnits: "objectBoundingBox",
    id: "bbkai50a8a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-61.4%",
    y: "-54%",
    width: "222.7%",
    height: "208%",
    filterUnits: "objectBoundingBox",
    id: "l19s04dk5b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.867136416 0 0 0 0 0.60887409 0 0 0 0 0.200819615 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "9xuyjs0uqd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E4C2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 0h4a2 2 0 0 1 2 2v21a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm14 0h4a2 2 0 0 1 2 2v21a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    id: "l2rbyo96bc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0.992,
    fill: "#F1BF70",
    filter: "url(#bbkai50a8a)",
    x: 12.08,
    y: 30.222,
    width: 47.84,
    height: 31.778,
    rx: 15.889
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F1BF70",
    cx: 36,
    cy: 36,
    r: 26
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 24)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#l19s04dk5b)",
    xlinkHref: "#l2rbyo96bc"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#9xuyjs0uqd)",
    xlinkHref: "#l2rbyo96bc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stopIcon.d4bf7997767b06105644886f386b8c09.svg";
export { ForwardRef as ReactComponent };